import TomSelect from "tom-select";

class selectFeedProduct extends HTMLElement {
  constructor() {
    super();
    this.$el = this.querySelector('select');
    this.$hiddenInput = this.querySelector('input[type="hidden"]');
    this.$script = this.querySelector('script');
    this.initialValue = { feed_type: null, feed_product_id: null };
    this.prefilledOptions = [];
  }

  connectedCallback() {
    this.initTomSelect();
  }

  initTomSelect() {
    if (this.$script) {
      const data = JSON.parse(this.$script.textContent);
      this.initialValue = data.selected || { feed_type: null, feed_product_id: null };
      this.prefilledOptions = data.prefilledOptions || [];
    } else {
      throw new Error("No script tag with JSON data found inside select-feed-product element.");
    }

    let settings = {
      create: true,
      sortField: {
        field: "text",
        direction: "asc"
      },
      allowEmptyOption: true,
      placeholder: this.$el.getAttribute('placeholder') || 'Select an option...',
      onChange: this.onChange.bind(this),
      render: {
        option: this.renderOption.bind(this)
      }
    };

    const tomSelect = new TomSelect(this.$el, settings);

    // If a custom species value is the initialValue, add it to TomSelect and select it
    if (this.initialValue.feed_type) {
      tomSelect.addOption({ value: this.initialValue.feed_type, text: `${this.initialValue.feed_type} (custom value)` }, true);
      tomSelect.addItem(this.initialValue.feed_type);
      this.onChange(this.initialValue.feed_type);
    }

    if (tomSelect.control_input) {
      tomSelect.control_input.setAttribute('tabindex', '0');
    }
  }

  onChange(value) {
    const match = this.prefilledOptions.find(option => option.id === parseInt(value));
    if (match === undefined) {
      this.$el.name = 'feed[feed_type]';
      this.$hiddenInput.name = 'feed[feed_product_id]';
    } else {
      this.$el.name = 'feed[feed_product_id]';
      this.$hiddenInput.name = 'feed[feed_type]';
    }
  }

  renderOption(item, escape) {
    const matchedItem = this.prefilledOptions.find(option => option.id === parseInt(item.value));
    if (matchedItem) {
      return '<div class="flex flex-col py-2">' +
        '<span class="font-medium">' + escape(matchedItem.display_name) + '</span>' +
        '<span class="text-sm text-gray-500 opacity-50 italic">' + escape(matchedItem.brand) + '</span>' +
        '</div>';
    } else {
      // For custom feed type - just show the value
      return '<div class="flex flex-col py-2">' +
        '<span class="font-medium">' + escape(item.text || item.value) + '</span>' +
        '</div>';
    }
  }
}

customElements.define("select-feed-product", selectFeedProduct);

export default selectFeedProduct;